export const captchaSiteKey = "6LdxZxojAAAAAOdt8fvACAygG1YNa4L2-C9XsKEY";
